module.exports = __webpack_public_path__ + "static/media/preview.a8ec103b.jpg";